import { useEffect } from 'react';

interface Props {
  count: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDeleteModal({ count, onConfirm, onCancel }: Props) {
  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onCancel();
      if (event.key === 'Enter') onConfirm();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onCancel, onConfirm]);

  return (
    <div className="editor-modal-shroud" onClick={onCancel}>
      <div
        className="editor-modal ui-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-delete-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header>
          <h3 id="confirm-delete-modal-title">Delete {count} objects?</h3>
        </header>
        <p>
          This will remove <strong>{count}</strong> objects from the current scene. You can undo this action with{' '}
          <kbd>Ctrl+Z</kbd>.
        </p>
        <footer>
          <button type="button" className="editor-action-btn" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="editor-delete-btn" onClick={onConfirm}>
            Delete {count}
          </button>
        </footer>
      </div>
    </div>
  );
}
